function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Artboard");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Artboard"
}, React.createElement("g", {
  id: "delete"
}, React.createElement("path", {
  d: "M67,10.2 L49.9,10.2 L49.1,4.1 C49,2 47.2,0.3 45.1,0.3 L24.9,0.3 C22.8,0.3 21,2 20.9,4.1 L20.1,10.2 L3,10.2 C1.3,10.2 0,11.5 0,13.2 C0,14.9 1.3,16.2 3,16.2 L6.8,16.2 L14.4,67.9 C14.5,70 16.3,71.6 18.4,71.6 L51.5,71.6 C53.6,71.6 55.3,70 55.5,67.9 L63.1,16.2 L67,16.2 C68.7,16.2 70,14.9 70,13.2 C70,11.5 68.7,10.2 67,10.2 Z M26.2,10.2 L26.7,6.4 L43.4,6.4 L43.9,10.2 L26.2,10.2 Z",
  id: "Shape"
})));

var SvgRemove = function SvgRemove(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "70px",
    height: "72px",
    viewBox: "0 0 70 72",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRemove, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/remove.bdea2df6.svg";
export { ForwardRef as ReactComponent };